/**
 * @generated SignedSource<<0674549e05f953f3fddcb578274d7486>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type issuesNewsletterArticleArticle$data = {
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityUuid: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"issuesDropdownNewsletterArticleArticle">;
  readonly " $fragmentType": "issuesNewsletterArticleArticle";
};
export type issuesNewsletterArticleArticle$key = {
  readonly " $data"?: issuesNewsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"issuesNewsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "issuesNewsletterArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityUuid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "issuesDropdownNewsletterArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "ae774c86de3f7da7c8ef883b0baff9da";

export default node;
